import { render, staticRenderFns } from "./PrinterComponentManageList.vue?vue&type=template&id=5955d96e&"
import script from "./PrinterComponentManageList.vue?vue&type=script&lang=js&"
export * from "./PrinterComponentManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports